module.exports = __webpack_public_path__ + "img/tv.29b7545e.svg";